import { DateTime } from 'luxon'

export class Role {
	public id: number
	public public_name: string
	public description: string | null
	public createdAt: DateTime | null
	public updatedAt: DateTime | null

	constructor(data: {
		id: number
		public_name: string
		description?: string | null
		createdAt?: DateTime | null
		updatedAt?: DateTime | null
	}) {
		this.id = data.id
		this.public_name = data.public_name
		this.description = data.description ?? null
		this.createdAt = data.createdAt ?? null
		this.updatedAt = data.updatedAt ?? null
	}

	static create(partial: Partial<Role>): Role {
		const defaults = {
			id: 0,
			public_name: '',
			description: null,
			createdAt: null,
			updatedAt: null,
		}

		return new Role({ ...defaults, ...partial })
	}
}
